import Vue from 'vue';

import Calculator from './vue-calculator.vue';

export default (el) =>
  new Vue({
    el,
    render: (h) => h(Calculator),
  });
